require("./ShippingTab.less");
import AsnDetailStore from "../../../stores/AsnDetailStore";
import AsnShippingPalletStore from "../../../stores/AsnShippingPalletStore";
import AsnStore from "../../../stores/AsnStore";
import AbilityStore from "../../../stores/AbilityStore";
import {setElementsFromScope, show, hide, insertTextAndClean, combineElements,insertValAndManageFocus, setPhoneUs} from "../../../utilities/selectorHelpers";
import _ from "underscore";
import $ from "jquery";
import DetailPickupQuoteView from "./DetailPickupQuoteView";
import AsnShippingPalletRowsView from "./AsnShippingPalletRowsView";
import InboundCarrierView from "./InboundCarrierView";
import {fetchShippingQuotesForAsnData} from "../../../actions/quotes";
import AsnSerializer from "../../../serializers/AsnSerializer";
import QuickBtnGroup from "../../../components/QuickBtnGroup/QuickBtnGroup";
import {isBlank, isPresent} from '../../../utilities/general';
import { setSwitcheryWithoutChange, instantiateSwitchery} from '../../../utilities/instantiateSwitchery';

const elementsMap = {
  shippingEntryPoint: '.shipping-tab-entry-point',
  hasShippingPartnerEntryPoint: ".has-shipping-partner-entry-point",
  noShippingPartnerEntryPoint: ".no-shipping-partner-entry-point",
  shippingPartnerRadioYes: ".shipping-partner-radio-yes",
  shippingPartnerRadioNo: ".shipping-partner-radio-no",
  shippingQuestion: ".inbound-shipping-question",
  shippingChoiceLabel1: ".inbound-shipping-choice-label-1",
  shippingChoiceLabel2: ".inbound-shipping-choice-label-2",
  fedExGroundMsg: ".fedex-grnd-msg",
  dvlSwitchery: "#declared-value-switchery",
  ifShippingCaseInternationally: ".if-shipping-case-internationally",
  shppingPartnerInputVal : ".shipping-partner-val",
  shippingFreightChk : ".freight-shipping",
  asnShipmentPalletEntryPoint : "#pallet-for-case-container",
  asnDetailsRowSection: ".asn-detail-rows-section",
  asnDetailRows: ".shipping-asn-details-rows-outer",
  dvlForAll:".declared-val-for-all",
  printShippingLabelFlag: ".print-shipping-label-flag"
 };

export default function ShippingTab(wizard){
  const self = this;
  const wizardElement = wizard.getWizardElement();
  const shippingTab = wizardElement.find('.shipping-tab');
  const csrEmailUrl = wizardElement.data("csr-email-url");
  const requestQuoteUrl = wizardElement.data('request-quote-url');
  const namespace = wizardElement.data('namespace');
  const areYouReadyToShipSection= wizardElement.find(".shipping-tab-are-you-ready-to-ship-section");
  const shippingInformationSection= wizardElement.find(".shipping-tab-shipping-information-section");
  const shipLaterBtn= wizardElement.find(".shipping-tab-ship-later");
  const shipNowBtn= wizardElement.find(".shipping-tab-ship-now");
  const inboundShipmentToggler= wizardElement.find(".inbound-shipment-toggler");
  const frieghtShippingToggler= wizardElement.find(".frieght-shipping-toggler");
  const freightShippingPalletInfo = wizardElement.find("#freight-shipping-pallet-info");
  const numberOfPallateInputForCase = wizardElement.find("#number-of-pallate-input-for-case");
  const shippingFreightSection= wizardElement.find(".shipping-tab-freight-shipping");
  const frieghtShippingOptionRadioYes= wizardElement.find(".frieght-shipping-option-radio-yes");
  const frieghtShippingOptionRadioNo= wizardElement.find(".frieght-shipping-option-radio-no");
  const numberOfPallets = wizardElement.find("#num-of-pallets");
  const numberOfPalletsBtn = wizardElement.find("#num-of-pallets-btn");
  const detailPickupQuoteView =wizardElement.find(".detail-pickup-quote-view-outer");
  const freightShippingOption = wizardElement.find("#frieght-shipping-option");
  const caseShippingOption = wizardElement.find("#case-shipping-option");
  const asnDetailRowsViewEntryPoint = wizardElement.find(".asn-detail-rows-view-entry-point");

  const tab = wizardElement.find(".location-tab");
  const countriesPhoneCode  =  $(".shipping-tab-entry-point").data('country-phone-code-list');
  const defaultCarrier = wizardElement.data('default-carrier');
  const carrierBrokerOrgType = wizardElement.data('carrier-broker-org-type');
  const carrierCreateUrl = wizardElement.data('create-carrier-org-url');
  
	const SHIPPING_TEXT = {
    shippingQuestionPallet: wizardElement.data("inbound-shipping-question-pallet"),
    shippingQuestionParcel: wizardElement.data("inbound-shipping-question-parcel"),
    shippingChoiceLabelYesPallet: wizardElement.data("inbound-shipping-choice-label-yes-pallet"),
    shippingChoiceLabelNoPallet: wizardElement.data("inbound-shipping-choice-label-no-pallet"),
    shippingChoiceLabelYesParcel: wizardElement.data("inbound-shipping-choice-label-yes-parcel"),
    shippingChoiceLabelNoParcel: wizardElement.data("inbound-shipping-choice-label-no-parcel")
  };

  let inboundCarrierView;

  const els = {};

  let isOnTab = false;

  self.init = function(){
    render();
  };

  function render(){
    setElements();
    attachWidgets();
    bindElements();
    bindStores();
    updateSelf();
    generateBtnGroup();
    assignDefualtPrintShippingLabelFlag();
  }

  function assignDefualtPrintShippingLabelFlag(){
    if(getAsn().status == "New"){
      AsnStore.updateObjectAndEmit(getAsnId(), {["printShippingLabelFlag"]: true});
     }else{
      instantiateSwitchery(els.printShippingLabelFlag, {});
      setSwitcheryWithoutChange($(els.printShippingLabelFlag), getAsn().printShippingLabelFlag);
     }
  }

  function generateBtnGroup() {

    const costRetailBtnGroup = new QuickBtnGroup(inboundShipmentToggler, {
      distributeWidth: true
    });
    costRetailBtnGroup.init();

    const frieghtShippingGroup = new QuickBtnGroup(frieghtShippingToggler, {
      distributeWidth: true
    });
    frieghtShippingGroup.init();

    let carrierBrokerTogglerGroup = new QuickBtnGroup(wizardElement.find(".carrier-broker-toggler"), {
      distributeWidth: true
    });
    carrierBrokerTogglerGroup.init();


  }

  function updateSelf(){
   //AsnStore.updateObjectAndEmit(getAsnId(), {"applyDvl": true});
    setValues();
    setShippingValue();
    handleDisable();
	  handleDisableNew();
    setText();
    toggleSubViews();
  }

 // We can delete this method later.
  function handleDisable(){
    const radios = combineElements([
      els.shippingPartnerRadioYes,
      els.shippingPartnerRadioNo
    ])
    radios.attr("disabled", !canEditGtlAsn());
    if(AsnStore.getCarrierBroker()==undefined || AsnStore.getCarrierBroker()==""){
      AsnStore.selectCarrierBroker('carrier');
    }

    if(AsnStore.getCarrierBroker()=='broker'){
      show(wizardElement.find(".show-broker-feilds"));
      hide(wizardElement.find(".show-carrier-feilds"));
    }else{
      show(wizardElement.find(".show-carrier-feilds"));
      hide(wizardElement.find(".show-broker-feilds"));
    }
    //hide(wizardElement.find(".show-broker-feilds"));
  }

  function handleDisableNew(){
    const shippingChoices = combineElements([
      els.shippingPartnerRadioYes,
      els.shippingPartnerRadioNo
    ])
    shippingChoices.attr("disabled", !canEditGtlAsn());
  }

  function setShippingValue(){

   if(hasShippingPartnerSelected())
   {
    if(hasShippingPartner())
    {
      $(els.shppingPartnerInputVal).val("true");
      $(els.shippingPartnerRadioNo).removeClass("active");
      $(els.shippingPartnerRadioYes).addClass("active");
    }
    else
    {
      $(els.shippingPartnerRadioNo).addClass("active");
      $(els.shippingPartnerRadioYes).removeClass("active");
      $(els.shppingPartnerInputVal).val("false");

    }
   }else{
     $(els.shippingPartnerRadioYes).removeClass("active");
     $(els.shippingPartnerRadioNo).removeClass("active");
   }
  }

  function setValues(){
    els.shippingPartnerRadioYes.prop('checked', hasShippingPartner());
    els.shippingPartnerRadioNo.prop('checked', (hasShippingPartnerSelected() && !hasShippingPartner()));
    if(hasFreigthSelected(getAsnId())){
      els.shippingFreightChk.prop('checked', true);
    }else{
      els.shippingFreightChk.prop('checked', false);
    }
    
    if(getAsn().applyDvl) {
      setSwitcheryWithoutChange($(elementsMap.dvlForAll), true);
      //$(elementsMap.dvlForAll).prop("checked", getAsn().applyDvl);
    } else {
      setSwitcheryWithoutChange($(elementsMap.dvlForAll), false);
      //$(elementsMap.dvlForAll).prop("checked", false);
    }

    handleShowHideFields(getAsnId());
  }

  function setText(){
    if(isPallet()){
      insertTextAndClean(els.shippingQuestion, SHIPPING_TEXT.shipingQuestionPallet);
      insertTextAndClean(els.shippingChoiceLabel1, SHIPPING_TEXT.shippingChoiceLabelYesPallet);
      insertTextAndClean(els.shippingChoiceLabel2, SHIPPING_TEXT.shippingChoiceLabelNoPallet);
    }
    else{
      insertTextAndClean(els.shippingQuestion, SHIPPING_TEXT.shippingQuestionParcel);
      insertTextAndClean(els.shippingChoiceLabel1, SHIPPING_TEXT.shippingChoiceLabelYesParcel);
      insertTextAndClean(els.shippingChoiceLabel2, SHIPPING_TEXT.shippingChoiceLabelNoParcel);
    }
  }

  
  function toggleSubViews(){
    // if nothing selected, show no subview
    hideAllSubviews();
    if(hasShippingPartnerSelected()){
      show(shippingInformationSection);
      hide(areYouReadyToShipSection);

      if(hasShippingPartner()){
        if(isInternational())
        {
          show(els.ifShippingCaseInternationally);
        }
        else{
          
          if(getAsnDetails().length > 0 && !isPallet()){
            show(freightShippingPalletInfo);
            if(hasFreigthSelected(getAsnId()) != undefined){
              if(hasFreigthSelected(getAsnId()) == true){
                show(numberOfPallateInputForCase);
                const shippingPalletsData = AsnShippingPalletStore.getAllAsnShippingPallets();
                const shippingPallets = Object.keys(shippingPalletsData).length;
                if(!$.isEmptyObject(shippingPalletsData)){
                  freightShippingOption.addClass("active");
                  caseShippingOption.removeClass("active");
                  numberOfPallets.val(shippingPallets);
                  populateAsnShippingPalletsData(shippingPallets);
                  show(els.hasShippingPartnerEntryPoint);
                }else{
                  freightShippingOption.removeClass("active");
                  caseShippingOption.addClass("active");
                }
              }else{
                if(getAsn().shippingMethod === "parcel"){
                  freightShippingOption.removeClass("active");
                  caseShippingOption.addClass("active");
                }
                show(els.hasShippingPartnerEntryPoint);
                show(els.dvlSwitchery);
                show(els.fedExGroundMsg);
              }
            }else{
              show(els.hasShippingPartnerEntryPoint);
              show(els.fedExGroundMsg);
            }
          }else if(isPallet()){
           show(els.hasShippingPartnerEntryPoint);
           show(els.fedExGroundMsg);
          }
          
        }
       /*  if(isPallet()){
           hide(freightShippingPalletInfo);
           show(els.hasShippingPartnerEntryPoint);
           show(els.fedExGroundMsg);
         }*/
    
      }
      else{
        if(!hasFreigthSelected(getAsnId()))
        {
          defualtViews();
        }
         show(els.noShippingPartnerEntryPoint);
        if(!isPallet() ){
         show(shippingFreightSection);
        }
      }
    }
      if(!hasFreigthSelected(getAsnId())){
         if(getAsnDetails().length > 0 && !isPallet()){
          toggleCaseInformationSection();  
         }
        
      }
  }

  function getDefaultCarriers(){
    return defaultCarrier;
  }

  function getCarrierCreateUrl(){
    return carrierCreateUrl;
  }


  function defualtViews(){
    const bolNumberOuter = wizardElement.find(".bol-number-outer");
    const trackingNumberOuter = wizardElement.find(".tracking-number-outer");
    hide(bolNumberOuter);
    hide(trackingNumberOuter);
    if(isPallet()){
       show(bolNumberOuter);
    }
    else
    {
      show(trackingNumberOuter);

    }
  }

  function isInternational(){

    return getAsn().isInternaltional;
  }

  self.isInternational = isInternational;

  function hideAllSubviews(){
    hide(els.hasShippingPartnerEntryPoint);
    hide(els.noShippingPartnerEntryPoint);
    hide(shippingFreightSection);
    hide(els.dvlSwitchery);
    hide(els.fedExGroundMsg);
    hide(els.ifShippingCaseInternationally);
    hide(freightShippingPalletInfo);
    hide(numberOfPallateInputForCase);
    
  }

  function setElements(){
    setElementsFromScope(els, elementsMap, shippingTab);
    if(carrierBrokerOrgType != undefined){
      AsnStore.selectCarrierBroker(carrierBrokerOrgType.toLowerCase())
   }
  }

  function attachWidgets(){
    const detailPickupQuoteView = new DetailPickupQuoteView(null, {
      getAsn,
      getAsnDetailGroups: getOrganizedAsnDetails,
      // onLengthChange: onDimChangeFunc("setLengthForIds"),
      // onWidthChange: onDimChangeFunc("setWidthForIds"),
      // onHeightChange: onDimChangeFunc("setHeightForIds"),
      // onWeightChange: onDimChangeFunc("setWeightForIds"),
      onAsnDetailGroupFieldChange,
      hasShippingPartnerSelected,
      hasShippingPartner,
      onAsnFieldsChange,
      onAsnFieldChange,
      csrEmailUrl,
      onRequestQuoteClicked,
      isPallet,
      readOnly: !canEditGtlAsn(),
      didAttemptToNavigateAwayFromCurrentForm
    });
    detailPickupQuoteView.init();
    els.hasShippingPartnerEntryPoint.html(detailPickupQuoteView.getElement());


    inboundCarrierView = new InboundCarrierView(null, {
      getAsn,
      getAsnDetailGroups: getOrganizedAsnDetails,
      isPallet,
      onShippingMethodChange,
      onAsnFieldChange,
      readOnly: !canEditGtlAsn(),
      onAsnDetailGroupFieldChange,
      onFieldCloneToAsnDetailsChange,
      getAllCountriesPhoneCode,
      onCountryPhoneCodeChange,
      getDefaultCarriers,
      setPhoneUsClass,
      getCarrierCreateUrl
    });
    inboundCarrierView.init();
    els.noShippingPartnerEntryPoint.html(inboundCarrierView.getElement());
    $("#asn-carrier-country-phone-code").val(getAsn().asn_carrier_phone_code).trigger("change");
  }


  function getAllCountriesPhoneCode(){
    return countriesPhoneCode;
  }

  function onFieldCloneToAsnDetailsChange(key, value){
    if(!isBlank(key))
    {
      AsnDetailStore.copyObjectToAllCasesViaAsnId(getAsnId(), {[key]: value});
    }
  }

  function onAsnShippingPalletFieldChange(key, val){
    // we must handle auto invalidation here,
    // because the user will be on the actual shipping tab,
    // at this point
    AsnStore.updateObjectAndEmit(getAsnId(), {[key]: val});
  }

  function onAsnFieldsChange(obj){
    // we must handle auto invalidation here,
    // because the user will be on the actual shipping tab,
    // at this point
    AsnStore.updateObjectAndEmit(getAsnId(), obj);
  }

  function onAsnShippingPalletFieldsChange(obj){
    // we must handle auto invalidation here,
    // because the user will be on the actual shipping tab,
    // at this point
    AsnShippingPalletStore.updateObjectAndEmit(getAsnId(), obj);
  }

  function onAsnFieldChange(key, val){
    // we must handle auto invalidation here,
    // because the user will be on the actual shipping tab,
    // at this point
    if(key==="pickupDate" || key==="insidePickup" || key==="pickupTimeFrom" || key==="pickupTimeTo" || key==="liftGatePickup" || key==="limitedAccess" || key==="asn_expected_arrival_date" || key==="asn_carrier_name" || key==="asn_carrier_contact_name" || key==="asn_carrier_contact_name" || key==="asn_carrier_phone" || key==="asn_bol_pro_number" || key==="freightShipping" || key==="asn_save_carrier"){
      AsnStore.updateObjectAndEmit(getAsnId(), {[key]: val});
    }else{
      AsnShippingPalletStore.updateObjectAndEmit(getAsnId(), {[key]: val});
    }
    
  }

  function onAsnDetailGroupFieldChange(rowIdx, key, val){
    const ids = _(getGroupAtIdx(rowIdx)).pluck("id");
    AsnDetailStore.setAttrsForIds(ids, {[key]: val});
  }

  function onAsnShippingPalletsGroupFieldChange(rowIdx, key, val){
    const ids = _(getAsnShippingPalletsGroupAtIdx(rowIdx)).pluck("id");
    AsnShippingPalletStore.setAttrsForIds(ids, {[key]: val});
  }

  function bindElements(){
    
    instantiateSwitchery(els.dvlForAll);
    instantiateSwitchery(els.printShippingLabelFlag);

    if(canEditGtlAsn()) {
      els.shippingPartnerRadioYes.on("click", handleRadioFunc(true));
      els.shippingPartnerRadioNo.on("click", handleRadioFunc(false));
    }

    els.shippingFreightChk.on("click",handleAsnFieldCheckboxChange("freightShipping"));

    frieghtShippingOptionRadioYes.on("click", function(e){
      e.preventDefault();
      caseShippingOption.removeClass("active");
      AsnStore.updateObjectAndEmit(getAsnId(), {freightShipping: true});
      AsnStore.emitEvent("freight_shipping_change");
    });

    frieghtShippingOptionRadioNo.on("click", function(e){
      e.preventDefault();
      caseShippingOption.addClass("active");
      AsnStore.updateObjectAndEmit(getAsnId(), {freightShipping: false});
      AsnStore.emitEvent("freight_shipping_change");
      toggleCaseInformationSection(e);
    });

    numberOfPalletsBtn.on('click', function(){
     createPalletRows();
    });

     numberOfPallets.on('blur', function(){
     createPalletRows();
    });

    els.dvlForAll.on("change", onChangeofDvlForAll);
    els.printShippingLabelFlag.on("change", onChangeofPrintShippingLabelFlag);
    //AsnStore.updateObjectAndEmit(getAsnId(), {["applyDvl"]: els.dvlForAll.is(":checked")});
    
    wizardElement.find(".carrier-broker-toggler").on('click', toggleCarrierBroker);
  }


  function onChangeofDvlForAll() {
    AsnStore.updateObjectAndEmit(getAsnId(), {["applyDvl"]: els.dvlForAll.is(":checked")});
    AsnStore.emitEvent("dvl-inside-case");
  }

  function onChangeofPrintShippingLabelFlag() {
   AsnStore.updateObjectAndEmit(getAsnId(), {["printShippingLabelFlag"]: els.printShippingLabelFlag.is(":checked")});
  }

  function toggleCarrierBroker(e){

    const btn = $(e.target);
    const btnKey = btn.data('qb-key');
    if(btnKey==='broker'){
      show(wizardElement.find(".show-broker-feilds"));
      hide(wizardElement.find(".show-carrier-feilds"));
      AsnStore.selectCarrierBroker('broker');
    }else{
      hide(wizardElement.find(".show-broker-feilds"));
      show(wizardElement.find(".show-carrier-feilds"));
      AsnStore.selectCarrierBroker('carrier');
    }
  }

  function createPalletRows(){
     AsnShippingPalletStore.removeAllAsnShippingPallets();
        els.asnShipmentPalletEntryPoint.html('')
        let totalNewPallets = numberOfPallets.val();
        for(var i=0; i< totalNewPallets; i++){
          let newAsnShippingPallet = {asnId:getAsn().id, rowIdx:i, asp_pallet_length:"", asp_pallet_width: "", asp_pallet_height:"",asp_pallet_weight:"",asp_pallet_stackable:false};
          AsnShippingPalletStore.createNewAsnShippingPalletDetail(newAsnShippingPallet);
        }
        AsnShippingPalletStore.emitEvent('shipping_pallets_change');
  }

  function populateAsnShippingPalletsData(numberOfPallets){
    const asnShippingPalletRowsView = new AsnShippingPalletRowsView(null, {
        getAsn,
        getAsnShipppingPallets,
        onAsnShippingPalletFieldsChange, 
        onAsnShippingPalletFieldChange,
        onAsnShippingPalletsGroupFieldChange,
        numberOfPallets
      });
     asnShippingPalletRowsView.init();
     $(elementsMap.asnShipmentPalletEntryPoint).html($(asnShippingPalletRowsView.getElement()[0]).html());
  }

  function removeAllAsnShippingPallets(e){
   AsnShippingPalletStore.removeAllAsnShippingPallets();
  }

  function handleAsnFieldCheckboxChange(key){
    return function(e){
      onAsnFieldChange(key, $(this).is(":checked"));
     }
  }

  function handleRadioFunc(type){
    return ()=>{
      if(type){
        // force FedEx because "yes, please provide me an inbound shipping quote"
        // implicitly means they are selecting FedEx
        AsnStore.updateObjectAndEmit(getAsnId(), {inboundCarrier: "FedEx"});
      }
      AsnStore.selectShippingPartner(getAsn(), type);
    }
  }

 /* function handleFreihtShipping(defaultVal)
  {
    return ()=>{
       AsnStore.selectFreightShipping(getAsn(), defaultVal);
    }
  }*/

   function handleShowHideFields(asnId){
    const bolNumberOuter = wizardElement.find(".bol-number-outer");
    const trackingNumberOuter = wizardElement.find(".tracking-number-outer");
    hide(bolNumberOuter);
    hide(trackingNumberOuter);
    if(hasFreigthSelected(asnId)){
      show(bolNumberOuter);
    }
    else
    {
      show(trackingNumberOuter);
    }

    if(AsnStore.getCarrierBroker() =='carrier'){
      show(wizardElement.find(".show-carrier-feilds"));
    }else{
      show(wizardElement.find(".show-broker-feilds"));
    }
  }

  function hasFreigthSelected(asnId){
    return AsnStore.hasFreigthSelected(asnId);
  }


  function bindStores(){
    AsnStore.bindListener("asns:shipping_method_changed", updateSelf);
    AsnStore.bindListener("asns:shipping_partner_changed", updateSelf);
//    AsnStore.bindListener("asns:carrier_broker_method_changed", updateSelf);
    //AsnStore.bindListener("asns:freight_shipping_changed", updateSelf);
    AsnStore.bindListener("asns:change", updateSelf);
    AsnShippingPalletStore.bindListener("asn_shipping_pallet:shipping_pallets_change", updateSelf);
    // only listen on asns:change here, because although we need to
    // invalidate quotes on asn_details change, we are specifically
    // setting a flag on the given asn quotesAreValid when anything
    // regarding that asn or it's asn_details change, followed by a
    // reset of all those flags, including quotesAreValid
    AsnStore.bindListener("asns:change", determineQuotesInvalidation);
  }

  function determineQuotesInvalidation(){
    // if we currently are on the Shipping Tab, AND
    // the quotes are set to be invalidated,
    // automatically force-remove quotes and reset flags
    if(self.isOnTab() && AsnStore.areQuotesInvalid(getAsn())){
      AsnStore.resetQuotesRelatedFlags(getAsn(), {showQuotesRemovedBecauseInfoChangedMessage: true});
    }
  }

  function hasShippingPartnerSelected(){
    return AsnStore.hasShippingPartnerSelected(getAsn());
  }

  self.hasShippingPartnerSelected = hasShippingPartnerSelected;

  function hasShippingPartner(){
    return AsnStore.hasShippingPartner(getAsn());
  }

  self.hasShippingPartner = hasShippingPartner;


  self.isParcel = function(){
    return AsnStore.isParcel(getAsn());
  }

  self.didRequestQuotes = function(){
    return AsnStore.didRequestQuotes(getAsn());
  }

  self.isFetchingQuotes = function(){
    return AsnStore.isFetchingQuotes(getAsn());
  }

  self.hasSelectedQuote = function(){
    return AsnStore.hasSelectedQuote(getAsn());
  }

  self.hasSpecialQuote = function(){
    return AsnStore.hasSpecialQuote(getAsn());
  }

  self.isGTL = function(){
    return AsnStore.isGTL(getAsn());
  }

  self.isPickupTimeRangeValid = function(){
    return AsnStore.isPickupTimeRangeValid(getAsn());
  }

  self.setIsOnTab = function(val){
    isOnTab = val;
  }

  self.isOnTab = function(){
    return isOnTab;
  }

  self.isCarrierNameValid = function(){
    return inboundCarrierView.isCarrierNameValid()
  }

  self.hasCasePackingPalletShipping = function(){
   const hasAsnShippingPalletsData = AsnShippingPalletStore.getAllAsnShippingPallets();
    let hasAsnShippingPallets = false;
    if(!$.isEmptyObject(hasAsnShippingPalletsData)){
      hasAsnShippingPallets = true;
    }
    return hasAsnShippingPallets;
  }

  function hasCasePackingPalletShippingData(){
    const hasAsnShippingPalletsData = AsnShippingPalletStore.getAllAsnShippingPallets();
    let hasAsnShippingPallets = false;
    if(!$.isEmptyObject(hasAsnShippingPalletsData)){
      hasAsnShippingPallets = true;
    }
    return hasAsnShippingPallets;
  }

  function canEditGtlAsn(){
    return AbilityStore.ask("canEditGtlAsn");
  }


  function getAsn(){
    return AsnStore.getAsnWithShippingMethod();
  }

  function getOrganizedAsnShippingPallets(){
    return AsnShippingPalletStore.organizeIntoPallets(getAsnShipppingPallets());
  }

  function getAsnShipppingPallets(){
    return AsnStore.getAsnShipppingPallets(getAsn());
  }

  function getAsnId(){
    return getAsn().id;
  }

  function getAsnDetails(){
    return AsnStore.getAsnDetails(getAsn());
  }

  function getAsnShippingPallets(){
    return AsnStore.getAsnShipppingPallets(getAsn());
  }

  function getOrganizedAsnDetails(){
    if(isPallet()){
      return AsnDetailStore.organizeIntoPallets(getAsnDetails());
    }else{
      return AsnDetailStore.organizeIntoCases(getAsnDetails());
    }
  }



  function getGroupAtIdx(idx){
    return getOrganizedAsnDetails()[idx];
  }

  function getAsnShippingPalletsGroupAtIdx(idx){
    return getOrganizedAsnShippingPallets()[idx];
  }

  function onShippingMethodChange(val){
    AsnStore.updateObjectAndEmit(getAsnId(), {inboundCarrier: val});
  }

   function onCountryPhoneCodeChange(val){
    AsnStore.updateObjectAndEmit(getAsnId(), {asn_carrier_phone_code : val});
    setPhoneUsClass(inboundCarrierView.getCarrierPhoneCode(), val);
  }

  function setPhoneUsClass(element, val){
    setPhoneUs([element], val);
  }


  function onDimChangeFunc(asnDetailAttrSetFuncName){
    return (rowIdx, val)=>{
      const ids = _(getGroupAtIdx(rowIdx)).pluck("id");
      AsnDetailStore[asnDetailAttrSetFuncName](ids, val);
    }
  }

  function onRequestQuoteClicked(){
    handleFetchingShippingQuoteForCurrentAsn();
    shippingTab.trigger("wizard:reconcileHeight");
  }

  function handleFetchingShippingQuoteForCurrentAsn(){
    const data = {};
    const asn = getAsn();
    data[`${namespace}asn`]  = getSerializedAsn(asn);
    data[`${namespace}cadId`]  = $(`#${namespace}cadId`).val();
    data[`${namespace}facilities`]  = $(`#${namespace}facilities`).val();

    let url;
    if(isPallet()){
      // Quote url for sagar
      url = requestQuoteUrl;
    }else if(!isPallet()){
      if(hasFreigthSelected(getAsnId()) != undefined){
          if(hasFreigthSelected(getAsnId()) == true){
            show(numberOfPallateInputForCase);
            const shippingPallets = getAsnShipppingPallets();
            if(shippingPallets && shippingPallets.length > 0){
                url = requestQuoteUrl;
            }
          }
        }
    }
    else{
      url = csrEmailUrl;
    }

    fetchShippingQuotesForAsnData(asn.id, data, url);
  }

  function getSerializedAsn(asn){
    const asnSerializer = new AsnSerializer(asn);
    return asnSerializer.toJsonNestedIntoPalletsAndCases();
  }

  function didAttemptToNavigateAwayFromCurrentForm(){
    return wizard.didAttemptToNavigateAwayFromCurrentForm();
  }

  function isPallet(){
    return AsnStore.isPallet(getAsn());
  }


	$(shipNowBtn).on("click", function(e){
	  e.preventDefault();
	  show(shippingInformationSection);
	  hide(areYouReadyToShipSection);
	});

function toggleCaseInformationSection(event){
  if(caseShippingOption.hasClass("active")){
    show(els.hasShippingPartnerEntryPoint);
  }else{
    //show(els.hasShippingPartnerEntryPoint);
    //hide($(elementsMap.asnDetailsRowSection));
    hide(els.fedExGroundMsg);
  }
}


}



// WEBPACK FOOTER //
// ./src/pages/asns/ShippingTab/ShippingTab.js